
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import 'just-kebab-case';
import './labels-mixin.js';
import 'focus-visible/dist/focus-visible.js';
import './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import PendoIcon from './pendo-icon.js';
import 'vue';
import 'lodash/get';
import './pendo-loading-mixin.js';
import PendoLoadingIndicator from './pendo-loading-indicator.js';
import './pendo-button.js';
import 'lodash/isNumber';
import './table-auto-height-mixin.js';
import 'element-ui/lib/dialog';
import 'resize-observer-polyfill';
import PendoModal from './pendo-modal.js';

const validLoadingStates = ['loading', 'rejected', 'resolved'];
var script = {
  name: 'CsvModal',
  components: {
    PendoModal,
    PendoLoadingIndicator,
    PendoIcon
  },
  props: {
    status: {
      type: String,
      required: true,

      validator(status) {
        const isValid = validLoadingStates.includes(status);

        if (!isValid) {
          console.error(`Status "${status}" is not valid status. Valid status: ${validLoadingStates.join(', ')}`);
          return false;
        }

        return true;
      }

    },
    note: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      actionButtons: [{
        theme: 'app',
        type: 'secondary',
        label: 'Close',
        handler: this.closeModal
      }]
    };
  },

  methods: {
    closeModal() {
      this.$emit('close');
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('pendo-modal', {
    staticClass: "pendo-csv-modal",
    attrs: {
      "visible": _vm.visible,
      "action-buttons": _vm.actionButtons,
      "height": "auto",
      "title": "Download CSV",
      "esc-to-close": ""
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "pendo-csv-modal__body"
  }, [_vm.status === 'loading' ? _c('div', {
    staticClass: "pendo-csv-modal__state"
  }, [_c('pendo-loading-indicator', {
    attrs: {
      "size": "24"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pendo-csv-modal__text"
  }, [_vm._v("\n                Please wait. Generating CSV...\n            ")])], 1) : _vm._e(), _vm._v(" "), _vm.status === 'rejected' ? _c('div', {
    staticClass: "pendo-csv-modal__state"
  }, [_c('pendo-icon', {
    attrs: {
      "type": "minus-circle",
      "size": "24",
      "stroke": "#DB1111"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pendo-csv-modal__text pendo-csv-modal__error-message"
  }, [_vm._v("\n                Looks like something went wrong. Try downloading the CSV again or contacting support if this issue\n                persists.\n            ")])], 1) : _vm._e(), _vm._v(" "), _vm.status === 'resolved' ? _c('div', {
    staticClass: "pendo-csv-modal__state"
  }, [_c('a', {
    staticClass: "pendo-csv-modal__download-link",
    attrs: {
      "href": _vm.url,
      "target": "_blank",
      "rel": "noopener noreferrer",
      "download": ""
    }
  }, [_vm._v("\n                Click to Download CSV\n            ")])]) : _vm._e(), _vm._v(" "), _vm.note ? _c('div', {
    staticClass: "pendo-csv-modal__note"
  }, [_vm._v("\n            " + _vm._s(_vm.note) + "\n        ")]) : _vm._e()])]);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-csv-modal.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoCsvModal = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default PendoCsvModal;
